import dayjs from 'dayjs';
import { Card, Typography } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';

import Loading from 'components/Loading/Loading';
import { formatDollarsFromCents } from 'utilities/helpers';
import { formatDate } from 'utilities/datesAndTimes';
import { SETTLEMENTS_CADENCE_VALUES } from 'utilities/constants';
import EstimatedPaymentsBreakdown, {
  getStartDateText,
} from './EstimatedPaymentsBreakdown';

const CARD_STYLES = {
  root: { width: '100%' },
  body: {
    display: 'flex',
    flexDirection: 'column',
    padding: 'var(--spacing)',
  },
};

const { Text, Paragraph } = Typography;

const PaymentsCalculatorCard = ({
  loadingQuery,
  balanceLabel = 'Settlement Balance',
  balance,
  expirationDate,
  startDate,
  cadence,
  schedule,
  durationMonths,
}) => {
  const showCalculated = loadingQuery || schedule?.length > 0;
  const scheduleAmount = schedule?.[0]?.amount;
  const calculatedReady = !loadingQuery && scheduleAmount != null;

  return (
    <Card type="inner" title="Payments Calculator" styles={CARD_STYLES}>
      <Text>
        <Paragraph>
          {balanceLabel}: {formatDollarsFromCents(balance)}
          <br />
          <strong>Plan Due Date: {formatDate(dayjs(expirationDate))}</strong>
          <br />
          --
        </Paragraph>

        {showCalculated ? (
          !calculatedReady ? (
            <Loading size={24} />
          ) : (
            <>
              <Paragraph>
                <CalendarOutlined />{' '}
                <strong>{getStartDateText(startDate)}</strong>
              </Paragraph>
              {cadence === SETTLEMENTS_CADENCE_VALUES.ONE_TIME ? (
                <strong>
                  Offer consists of one payment of{' '}
                  {formatDollarsFromCents(scheduleAmount)}
                </strong>
              ) : (
                <>
                  <strong>
                    Offer consists of {schedule.length} payments of about:
                  </strong>
                  <br />
                  {formatDollarsFromCents(scheduleAmount)} | over{' '}
                  {durationMonths} months
                </>
              )}
            </>
          )
        ) : (
          <EstimatedPaymentsBreakdown
            amount={balance}
            durationMonths={durationMonths}
            expirationDate={expirationDate}
            startDate={startDate}
          />
        )}
      </Text>
    </Card>
  );
};

export default PaymentsCalculatorCard;
